<template>

    <div>
        <v-container fluid grid-list-xl class="assessment-start-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>
        </v-container>
        <v-layout row wrap class="pf-standard-mobile pf-mobile-sq">
        <v-flex lg4 offset-lg4 md8 offset-md2 sm8 offset-sm2 xs12>
            <p class="page-title-pf no-margin-bottom hidden-xs-only">{{text('api.pdf.pageTitle.startQuestions')}}</p>
          <standard-stepper :steps="step"></standard-stepper>

            <description ></description>

        </v-flex>
    </v-layout>
        <v-layout row wrap class=" margin-top-m pf-standard-mobile">
            <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 xs12>
                <div class=" start-assessment-section-pf pf-question">
                    <question-list-block
                        :questions="startQuestion.questions"
                        :title="text('db.product.PROD_TITLE_START')"
                        :questionsCountAnswered="startQuestion.countAnswered"
                        :questionsCountTotal="startQuestion.countTotal"
                        titleClasses="title-assessment-sections"
                        @onProvideAnswer="handleProvideAnswer">
                    </question-list-block>

                    <div class="pf-footer hidden-xs-only">
                        <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                            <v-icon>keyboard_arrow_left</v-icon>
                            {{ text('api.button.back') }}
                        </v-btn>
                        <v-btn flat color="primary" @click="goToNextPage"  :disabled="!isFooterNextBtnEnabled" class="footer-btn footer-btn-next next-pf">
                            {{ text('api.button.next') }}
                            <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-flex>

        </v-layout>

        <v-layout class="hidden-sm-and-up footer pf-standard-mobile">
                <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                    <v-icon>keyboard_arrow_left</v-icon>
                    {{ text('api.button.back') }}
                </v-btn>

                <mobile-stepper :steps="step"></mobile-stepper>

                <v-btn flat color="primary" @click="goToNextPage"  :disabled="!isFooterNextBtnEnabled" class="footer-btn footer-btn-next next-pf">
                    {{ text('api.button.next') }}
                    <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import HeaderBar from '../../shared/HeaderBar';
    import SymptomQuestionItem from "../../../../common/components/shared/SymptomQuestionItemPf";
    import {mapGetters} from 'vuex';
    import RadialProgressSvg from "../../../../common/components/svg/productList/radialProgress";
    import QuestionListBlock from "../../../../common/components/shared/QuestionListBlockPf";
    import Description from '../../shared/Description';
    import StandardStepper from '../../shared/StandardStepper';
    import MobileStepper from '../../shared/MobileStepper';


    export default {
        name: 'StartQuestionsPage',
        components: {
            HeaderBar,
            SymptomQuestionItem,
            RadialProgressSvg,
            QuestionListBlock,
            Description,
            StandardStepper,
            MobileStepper
        },
        props: ["percentage"],
        data(){
            return{
                fill : { gradient: ["red"] },
                items: 1,
                step:1,
                prevRoute: null
            }
        },
        computed: mapGetters({
            startQuestion: 'PfAssessmentStartStore/getStartQuestion',
            isFooterNextBtnEnabled: 'PfAssessmentStartStore/getIsFooterNextBtnEnabled'
        }),

        methods: {
            handleProvideAnswer(data) {

                this.$store.dispatch('PfAssessmentStartStore/submitStartQuestionAnswer', data);
            },
            goToPreviousPage() {
                this.$router.push('/pathfinder/home');
            },

            goToNextPage() {

                if (this.isFooterNextBtnEnabled) {
                    this.$router.push('/pathfinder/general-questions');
                    this.$store.commit('PfAssessmentStartStore/disableFooterBtnNext', false);

                }
            },
            goToMainSymptomPage() {
                this.$router.push('/pathfinder/main-symptom');
            },
        },
        created () {
          this.$store.dispatch("PfAssessmentStartStore/loadAssessmentStartData");
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .cont-svg{
        content: '%';
    }

    .progress-circle-status {
        max-width: 45px !important;
    }


    /*@media only screen and (max-width: 600px) {*/
        .pf-standard-mobile.pf-mobile-sq {
            margin-top: 0 !important;
            background-color: $color-gray-lightest;
        }

        .footer-btn-next.next-pf {
            position: absolute;
            right: 0;
            bottom: 4px;
        }

        .footer-btn.back-pf {
            position: absolute;
            top: 4px;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;

                &.btn--disabled {
                    color: rgba(164,58,69,.36) !important;

                    .icon {
                        color: rgba(164,58,69,.36) !important;
                    }
                }
            }

        }
    /*}*/

    @media only screen and (min-width: 601px) {
        .pf-standard-mobile.pf-mobile-sq {
            margin-top: 30px !important;
        }
    }
</style>




// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/start-questions/StartQuestionsPage.vue